// Configuration for compliance guidance content
export const guidanceConfig = {
  nis2: {
    essential: {
      nextSteps: `As an essential entity under NIS2, your immediate steps should be:
1. Establish a cybersecurity risk management system
2. Implement technical and organizational measures
3. Prepare incident reporting procedures
4. Ensure supply chain security`,
      videoId: "pK5KSg2f7OY", // Replace with actual video ID
      ctaUrl: "https://digital-strategy.ec.europa.eu/en/policies/nis2-directive",
      ctaText: "Learn More About NIS2 Essential Requirements"
    },
    important: {
      nextSteps: `As an important entity under NIS2, you should:
1. Implement basic cybersecurity measures
2. Conduct regular risk assessments
3. Set up incident reporting channels
4. Review your supply chain security`,
      videoId: "pK5KSg2f7OY", // Replace with actual video ID
      ctaUrl: "https://digital-strategy.ec.europa.eu/en/policies/nis2-directive",
      ctaText: "Explore NIS2 Important Entity Guidelines"
    },
    not_applicable: {
      nextSteps: `While NIS2 may not directly apply to you, consider:
1. Implementing basic cybersecurity measures (they will help anyhow)
2. Monitoring your growth for potential future applicability (know when you might become subject of Directive)
3. Following industry best practices`,
      videoId: "pK5KSg2f7OY", // Replace with actual video ID
      ctaUrl: "https://digital-strategy.ec.europa.eu/en/policies/cybersecurity-policies",
      ctaText: "Discover Cybersecurity Best Practices"
    }
  },
  dora: {
    direct: {
      nextSteps: `As a financial entity directly under DORA:
1. Review your ICT risk management framework
2. Establish incident reporting mechanisms
3. Conduct regular digital operational resilience testing
4. Manage third-party ICT risks`,
      videoId: "xxxxxxxx4", // Replace with actual video ID
      ctaUrl: "https://www.eba.europa.eu/activities/direct-supervision-and-oversight/digital-operational-resilience-act",
      ctaText: "Understand DORA Direct Requirements"
    },
    indirect: {
      nextSteps: `As an ICT service provider to financial entities:
1. Align your services with DORA requirements
2. Prepare for potential oversight framework
3. Review your contractual arrangements
4. Enhance your ICT risk management`,
      videoId: "xxxxxxxx5", // Replace with actual video ID
      ctaUrl: "https://www.eba.europa.eu/activities/direct-supervision-and-oversight/digital-operational-resilience-act",
      ctaText: "Learn About DORA Third-Party Requirements"
    },
    not_applicable: {
      nextSteps: `While DORA doesn't directly apply to you:
1. Consider implementing financial-grade ICT security
2. Monitor your business relationships with financial entities
3. Stay informed about digital operational resilience`,
      videoId: "xxxxxxxx6", // Replace with actual video ID
      ctaUrl: "https://www.eba.europa.eu/regulation-and-policy/digital-operational-resilience-act-dora",
      ctaText: "Explore Digital Operational Resilience"
    }
  },
  gdpr: {
    controller: {
      nextSteps: `As a data controller under GDPR:
1. Review your data processing activities
2. Update privacy notices and consent mechanisms
3. Implement data protection by design
4. Ensure proper data subject rights handling`,
      videoId: "xxxxxxxx7", // Replace with actual video ID
      ctaUrl: "https://gdpr.eu/",
      ctaText: "Master GDPR Controller Obligations"
    },
    processor: {
      nextSteps: `As a data processor under GDPR:
1. Review your data processing agreements
2. Implement appropriate security measures
3. Maintain records of processing activities
4. Ensure proper sub-processor management`,
      videoId: "xxxxxxxx8", // Replace with actual video ID
      ctaUrl: "https://gdpr.eu/processor-obligations/",
      ctaText: "Understand Processor Requirements"
    },
    both: {
      nextSteps: `As both a controller and processor under GDPR:
1. Clearly separate your controller and processor roles
2. Implement role-specific compliance measures
3. Review all data processing agreements
4. Ensure comprehensive GDPR compliance`,
      videoId: "xxxxxxxx9", // Replace with actual video ID
      ctaUrl: "https://gdpr.eu/",
      ctaText: "Learn About Dual Role Compliance"
    },
    not_applicable: {
      nextSteps: `While GDPR may not directly apply:
1. Consider implementing privacy best practices
2. Monitor your data handling activities
3. Stay informed about privacy regulations`,
      videoId: "xxxxxxxx10", // Replace with actual video ID
      ctaUrl: "https://gdpr.eu/what-is-gdpr/",
      ctaText: "Discover Privacy Best Practices"
    }
  }
};
